// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Silka", sans-serif !important;
}

.modal-dialog {
  max-width: 1000px;
  top: 7%;
}

.modal-content {
  position: relative;
  background-color: #555;
  border-radius: 1.5rem;
  border: 2px solid #ffd700;
  color: white;
  box-shadow: 0 0 25px rgba(0, 0, 0, 0.85);
  overflow: hidden;
  /* margin-top: 200px !important; */
}

.navbar-expand-lg .navbar-nav .dropdown-menu {
  font-size: 0.9rem;
  background-color: transparent;
  border: none;
  top: 20px;
}

.navbar-expand-lg .navbar-nav .dropdown-menu .dropdown-item {
  color: #fff;
  background-color: rgba(0, 0, 0, 1);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.navbar-expand-lg .navbar-nav .dropdown-menu .dropdown-item:hover {
  font-weight: 700;
  background-color: rgba(0, 0, 0, 0.7);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.navbar-expand-lg .navbar-nav .dropdown-menu .dropdown-item:active {
  font-weight: 700;
  background-color: rgba(0, 0, 0, 0.1);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.navbar-expand-lg .navbar-nav .dropdown-menu .dropdown-item:focus {
  font-weight: 700;
  background-color: rgba(0, 0, 0, 0.1);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,wCAAwC;EACxC,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,wCAAwC;AAC1C","sourcesContent":["body {\n  font-family: \"Silka\", sans-serif !important;\n}\n\n.modal-dialog {\n  max-width: 1000px;\n  top: 7%;\n}\n\n.modal-content {\n  position: relative;\n  background-color: #555;\n  border-radius: 1.5rem;\n  border: 2px solid #ffd700;\n  color: white;\n  box-shadow: 0 0 25px rgba(0, 0, 0, 0.85);\n  overflow: hidden;\n  /* margin-top: 200px !important; */\n}\n\n.navbar-expand-lg .navbar-nav .dropdown-menu {\n  font-size: 0.9rem;\n  background-color: transparent;\n  border: none;\n  top: 20px;\n}\n\n.navbar-expand-lg .navbar-nav .dropdown-menu .dropdown-item {\n  color: #fff;\n  background-color: rgba(0, 0, 0, 1);\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.navbar-expand-lg .navbar-nav .dropdown-menu .dropdown-item:hover {\n  font-weight: 700;\n  background-color: rgba(0, 0, 0, 0.7);\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.navbar-expand-lg .navbar-nav .dropdown-menu .dropdown-item:active {\n  font-weight: 700;\n  background-color: rgba(0, 0, 0, 0.1);\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.navbar-expand-lg .navbar-nav .dropdown-menu .dropdown-item:focus {\n  font-weight: 700;\n  background-color: rgba(0, 0, 0, 0.1);\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
